import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import paisService from "../services/pais.service";

const initialState = {
    paises: [],
    isLoading: false,
    isError: false,
    message: '',
    currentPage: 1,
    totalRows: 0,
};



export const createPais = createAsyncThunk(
    "pais/create",
    async ( paisData, thunkAPI ) => {
        try {
            return await paisService.createPais(paisData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const getPaises = createAsyncThunk(
    "paises/getPaises",
    async (data, thunkAPI) => {
        try {
            return await paisService.getAllPaises(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const getListSelectPais = createAsyncThunk(
    "paises/getListSelectPais",
    async (thunkAPI) => {
        try {
            return await paisService.getListSelectPais();
        } catch (error) {
            const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const updatePais = createAsyncThunk(
    "pais/update",
    async (paisData, thunkAPI ) => {
        try {
            const token = thunkAPI.getState().auth.user.token;
            return await paisService.updatePais(paisData, token);
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const deletePais = createAsyncThunk(
    "paises/deletePais",
    async (id, thunkAPI) => {
        try {
            return await paisService.deletePais(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const paisSlice = createSlice({
    name: "paises",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPaises.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPaises.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.paises = action.payload.data; // Asegúrate de que el backend retorne los datos bajo esta estructura
                state.currentPage = action.payload.pagination.por_pagina;
                state.totalRows = action.payload.pagination.cantidad;
            })
            .addCase(getPaises.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createPais.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPais.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.paises.push(action.payload);
            })
            .addCase(createPais.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deletePais.fulfilled, (state, action) => {
                state.isLoading = false;
                state.paises = state.paises.filter(pais => pais.id !== action.meta.arg); // Opcional si quieres filtrar localmente
            })
            .addCase(deletePais.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error eliminando el país';
            })
            .addCase(updatePais.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePais.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.paises = state.paises.map((pais) => 
                    pais.id === action.payload.id ? action.payload : pais);
            })
            .addCase(updatePais.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getListSelectPais.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.paises = action.payload; // 👈 el payload ya es el array plano, como lo viste en Postman
            })
    }
})

export const { reset } = paisSlice.actions;
export default paisSlice.reducer;